var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { consumerTheme, fontSizes } from "syf-component-library/defaultTheme";
export var colors = {
    error: "#C63527",
    lightError: "#F9EBE9",
    info: "#0072AD",
    success: "#3E8529",
    lightSuccess: "#f0faee",
    warning: "#caa416",
    deleteRedHover: "#ad1c0e",
    darkWarning: "#CAA416",
    white: "#FFFFFF",
    lightGrey: "#F6F6F6",
    mediumGrey: "#E0E0E0",
    darkGrey: "#656565",
    black: "#333333",
    silver: "#C0C0C0",
};
export var FontSizes = __assign(__assign({}, fontSizes), { smallRoot: 14 });
export var tag = {
    scheduled: {
        icon: "#3C777C",
        background: "#EEF6F7",
    },
    processingCharged: {
        icon: "#333333",
        background: "#E9EAEB",
    },
    posted: {
        icon: "#3E8529",
        background: "#ECF3EA",
    },
    canceled: {
        icon: "#C63527",
        background: "#F9EBE9",
    },
    rejected: {
        icon: "#C99E00",
        background: "#FFF9E6",
    },
    defaultColors: {
        icon: "#333333",
        background: " #E9EAEB",
    },
};
export var staticIcons = {
    statementsIconPrimary: "#34657F",
    statementsIconBackground: "#F0F3F5",
};
var _a = consumerTheme.meter, gradientStart = _a.gradientStart, gradientEnd = _a.gradientEnd, valueTextColor = _a.valueTextColor;
export var mockTheme = __assign(__assign(__assign({}, colors), staticIcons), { pieChart: {
        inProgress: "#34657f",
    }, body: {
        background: "#F6F6F6",
        text: "#333333",
    }, link: "#34657f", icon: "#34657f", 
    // The color used to alter the browser default focus color
    focus: "#34657f", 
    // For dropdown hover states, table row hover, and selected item background
    hoverBackground: "#E8F1FB", 
    // The colors used to set the default (html) body text color and body background color, not to be confused with the body typography element
    systemNavigation: {
        background: "#FFFFFF",
    }, modal: { background: "#FFFFFF", headerBackground: "#F6F6F6" }, accordion: {
        borderColor: "",
        headerBackgroundColor: "",
        activeHeaderBackgroundColor: "",
    }, button: {
        text: "#34657f",
        background: "#34657f",
        primary: {
            text: "#FFFFFF",
            hover: "#0072ad",
        },
        secondary: {
            text: "#34657f",
            hover: "#ebf0f2",
        },
    }, tooltip: {
        backgroundColor: "#ffffff",
        color: "#232323",
    }, binart: {
        background: "",
        disableBackground: "",
    }, field: {
        icon: "#34657f",
        focus: "#34657f",
        label: "#34657f",
    }, checkbox: {
        background: "#008A00",
        font: "#FFFFFF",
    }, chip: {
        hover: "",
        text: "",
    }, switch: {
        background: "#34657f",
    }, radio: {
        border: "",
        background: "",
    }, navigation: {
        activeTabText: "#34657f",
        activeTabBorder: "#34657f",
    }, datepicker: {
        legend: {
            selectedDate: {
                fill: "#34657f",
                border: "#34657f",
                text: "#ffffff",
            },
            dueDate: {
                fill: "#ffffff",
                border: "#000000",
                text: "#000000",
            },
            lateFeeDate: {
                fill: "#757575",
                border: "#757575",
                text: "#ffffff",
            },
        },
    }, footer: {
        background: "#FFFFFF",
        text: "#333333",
        border: "",
    }, header: {
        background: "#F6F6F6",
        text: "",
        border: "", // just dsecurity: headerDivider
    }, progressStepBar: {
        fill: "",
        hover: "",
        label: "",
    }, progressBar: {
        complete: "#3e8529",
        error: "#c63527",
        inProgress: "#0072ad",
        background: "#e9eaeb",
    }, meter: {
        valueTextColor: valueTextColor,
        gradientStart: gradientStart,
        gradientEnd: gradientEnd,
    }, notifications: {
        warning: "#fffaeb",
    } });
//# sourceMappingURL=theme.js.map